import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "sidebar" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear float" }, null, -1)
const _hoisted_7 = {
  style: {"margin-bottom":"30px"},
  class: "primary-sidebar widget-area",
  role: "complementary"
}
const _hoisted_8 = { class: "iblock center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: "/img/ref0002.jpg",
  style: {"width":"144px","padding":"2px","border":"1px solid #999"},
  alt: ""
}, null, -1)
const _hoisted_10 = { class: "iblock center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  style: {"border":"1px solid #999"},
  src: "/css/patent.jpg",
  alt: ""
}, null, -1)
const _hoisted_12 = {
  key: 1,
  id: "primary-sidebar",
  class: "primary-sidebar widget-area",
  role: "complementary"
}
const _hoisted_13 = {
  id: "recent-posts-2",
  class: "widget widget_recent_entries"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", { class: "widget-title" }, "Новости", -1)
const _hoisted_15 = ["href", "innerHTML"]
const _hoisted_16 = { class: "post-date" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://aurora-oil.ru/about/news/",
  class: "right mnofloat mcenter"
}, "Все новости »", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear float" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"iblock center social\"><h3>Мы в социальных сетях</h3><a rel=\"nofollow\" target=\"_blank\" href=\"https://www.youtube.com/channel/UC84yHSCWcCLs4i6lpGZP5VQ\"><img src=\"/css/my_yt.png\" alt=\"\"></a><a rel=\"nofollow\" target=\"_blank\" href=\"https://rutube.ru/channel/30418896/\"><img src=\"/css/my_ru.png\" alt=\"\" width=\"48px\"></a><a rel=\"nofollow\" target=\"_blank\" href=\"https://vk.com/auroraoil\"><img src=\"/css/my_vk.png\" alt=\"\"></a><a rel=\"nofollow\" target=\"_blank\" href=\"https://t.me/aurora_oil\"><img src=\"/css/my_tel.png\" alt=\"\" width=\"50px\"></a></div><div class=\"iblock center\"><a id=\"newsletter\" target=\"_blank\" href=\"https://oilaurora.ru/\">Подписаться на<br>наши новости</a></div><div class=\"iblock center\"><a target=\"_blank\" href=\"https://aurora-oil.ru/about/patents/sertifikat-sootvetstviya-sistemy-menedzhmenta-kachestva-proizvodstva-neftegazovogo-i-himicheskogo-oborudovaniya-trebovaniyam-gost-r-iso-9001-2015-iso-9001-2015-fsk-ru-002-f000246/\"><img src=\"/css/iso.jpg\" style=\"-webkit-filter:grayscale(100%);\" alt=\"\"></a></div><div class=\"iblock center\"><a href=\"https://play.google.com/store/apps/details?id=com.aurora.oil&amp;hl=ru&amp;gl=US\" target=\"_blank\"><img alt=\"Доступно в Google Play\" src=\"/css/google.png\" style=\"max-width:90%;\"></a><br><a href=\"https://apps.apple.com/us/app/%D0%B0%D0%B2%D1%80%D0%BE%D1%80%D0%B0-%D0%BD%D0%B5%D1%84%D1%82%D1%8C/id1544924782\" target=\"_blank\"><img alt=\"Доступно в Apple Play\" src=\"/css/apple.png\" style=\"max-width:100%;\"></a></div><div class=\"clear float\"></div>", 5)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/catalog",
      class: "big_a",
      id: "catalog"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Каталог оборудования")
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/oprosnye-listy",
      class: "big_a",
      id: "oprosnik2"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Скачать опросные листы")
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/oprosnii-list",
      class: "big_a",
      id: "oprosnik"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Прислать опросный лист")
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/price",
      class: "big_a",
      id: "askprice"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Запросить цену")
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/proektant",
      class: "big_a",
      id: "proektant"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Для проектировщиков")
      ]),
      _: 1
    }),
    _createVNode(_component_router_link, {
      to: "/video-veernoe-soplo",
      class: "sbanner2 video"
    }, {
      default: _withCtx(() => [
        _createTextVNode("Видео работы устройств размыва донных отложений")
      ]),
      _: 1
    }),
    _createElementVNode("a", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (this.openSchemeModal())),
      class: "sbanner2 cursorpointer"
    }, "Схема расположения оборудования на резервуаре"),
    (_ctx.getSidebar.gallery)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_2, "Фотогалерея "))
      : _createCommentVNode("", true),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSidebar.gallery, (gal) => {
        return (_openBlock(), _createElementBlock("li", {
          key: gal.id,
          style: {"list-style-type":"none"}
        }, [
          _createElementVNode("a", {
            target: "_blank",
            href: gal.url
          }, [
            _createElementVNode("img", {
              width: "150",
              height: "150",
              src: gal.img,
              class: "attachment-thumbnail size-thumbnail wp-post-image",
              alt: "",
              decoding: "async",
              loading: "lazy"
            }, null, 8, _hoisted_4),
            _createElementVNode("p", {
              innerHTML: gal.title
            }, null, 8, _hoisted_5)
          ], 8, _hoisted_3),
          _createElementVNode("span", null, _toDisplayString(gal.date), 1),
          _hoisted_6
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: "/about/gallery",
          class: "right mnofloat mcenter"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Вся галерея »")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("h3", null, [
        _createVNode(_component_router_link, { to: "/about/references" }, {
          default: _withCtx(() => [
            _createTextVNode("Отзывы")
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_router_link, { to: "/about/references" }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("h3", null, [
        _createVNode(_component_router_link, { to: "/about/patents" }, {
          default: _withCtx(() => [
            _createTextVNode("Сертификаты и патенты")
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_router_link, { to: "/about/patents" }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      })
    ]),
    (_ctx.getSidebar.news)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSidebar.news, (news) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: news.id
                }, [
                  _createElementVNode("a", {
                    target: "_blank",
                    href: news.url,
                    innerHTML: news.title
                  }, null, 8, _hoisted_15),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(news.date), 1)
                ]))
              }), 128))
            ])
          ]),
          _createTextVNode(),
          _hoisted_17,
          _hoisted_18
        ]))
      : _createCommentVNode("", true),
    _hoisted_19
  ]))
}